import { render, staticRenderFns } from "./SubCommunityMember.vue?vue&type=template&id=5b7721a4&scoped=true&"
import script from "./SubCommunityMember.vue?vue&type=script&lang=js&"
export * from "./SubCommunityMember.vue?vue&type=script&lang=js&"
import style0 from "./SubCommunityMember.vue?vue&type=style&index=0&id=5b7721a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7721a4",
  null
  
)

export default component.exports